import React from 'react';
const ForgetPassword = React.lazy(() =>
  import('./ForgotPassword/ForgotPassword')
);
const Login = React.lazy(() => import('./login/Login'));
const ResetPassword = React.lazy(() => import('./ResetPassword/ResetPassword'));
export const authRouteConfig = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/forget-password',
    element: <ForgetPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
];
